import { Helmet } from "react-helmet-async";

interface PageSeoProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  jsonLd?: object | object[];
}

const SITE = "https://www.mblearn.app";

/**
 * Per-route SEO head tags. Sets title, meta description, canonical, and
 * og:title/og:description/og:url for the current page so each route has
 * unique metadata (instead of inheriting the homepage's).
 */
export const PageSeo = ({ title, description, path, noindex, jsonLd }: PageSeoProps) => {
  const url = `${SITE}${path}`;
  const ldArr = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {ldArr.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};

export default PageSeo;
